import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { PLinkComponent } from './p-link.component';

@NgModule({
    declarations: [PLinkComponent],
    imports: [CommonModule, ExtendedModule, RouterModule],
    exports: [PLinkComponent]
})
export class PLinkModule {}
